import React from 'react';
import { IWeatherContext } from './types';
import { WeatherContentEntity } from './entities';
import { ACCESS_TOKEN_KEY, RECONNECT_TIME, WEATHER_SOCKET_URL } from '@src/core/config';
import { useGetUserDataQuery } from '@src/core/features';

export const WeatherContext = React.createContext<IWeatherContext>({});

const WeatherProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const socket = React.useRef<WebSocket>();
  const [data, setData] = React.useState<WeatherContentEntity>();
  const { data: userData } = useGetUserDataQuery();
  const hubId = userData?.hub?.id;

  const createSocket = React.useCallback(() => {
    if (!hubId) return;

    const hubURL = `?hubId=${hubId}`;
    const socketURL = WEATHER_SOCKET_URL;
    socket.current = new WebSocket(socketURL + hubURL);

    socket.current.onopen = () => {
      const token = localStorage.getItem(ACCESS_TOKEN_KEY);
      if (socket.current) {
        socket.current.send(JSON.stringify({
          type: 'AUTH',
          token,
        }));
      }
    };

    socket.current.onclose = () => {
      setTimeout(() => createSocket(), RECONNECT_TIME);
    };

    socket.current.onmessage = (event) => {
      try {
        const weatherData = JSON.parse(event.data);
        setData(weatherData as WeatherContentEntity);
      } catch (error) {
        console.error('Failed to parse weather data:', event.data);
      }
    };
  }, [hubId]);

  React.useEffect(() => {
    createSocket();
    return () => socket.current && socket.current.close();
  }, [createSocket]);

  return (
    <WeatherContext.Provider value={{ data }}>
      {children}
    </WeatherContext.Provider>
  );
};

export default WeatherProvider;